<div class="modal-backdrop" (click)="onClose()"></div>

<div class="modal-dialog" (click)="$event.stopPropagation()">
  <div class="modal-content">
    <!-- Header -->
    <div class="modal-header">
      <h3 class="modal-title">Add Cameras to Watch View</h3>
      <button type="button" class="btn-close" (click)="onClose()" aria-label="Close"></button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <!-- Selection Info -->
      <div class="selection-info alert alert-info">
        <i class="bi bi-info-circle"></i>
        Selected: <strong>{{ selectedCount }}</strong> / Available slots: <strong>{{ availableSlots }}</strong>
      </div>

      <!-- Search -->
      <div class="search-box mb-3">
        <input 
          type="text" 
          class="form-control" 
          placeholder="Search cameras..." 
          [(ngModel)]="searchTerm">
        <i class="bi bi-search search-icon"></i>
      </div>

      <!-- Cameras List -->
      <div class="tab-content-area">
        <!-- Loading -->
        <div *ngIf="loadingCameras" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading cameras...</span>
          </div>
          <p class="mt-3">Loading cameras...</p>
        </div>

        <!-- Error -->
        <div *ngIf="errorCameras && !loadingCameras" class="alert alert-danger">
          <i class="bi bi-exclamation-triangle"></i> Failed to load cameras. Please try again.
        </div>

        <!-- Camera List -->
        <div *ngIf="!loadingCameras && !errorCameras" class="item-list">
          <div *ngIf="filteredCameras.length === 0" class="empty-message">
            <i class="bi bi-camera-video-off fs-1 text-muted mb-3"></i>
            <p>No cameras found matching your search.</p>
          </div>

          <div 
            *ngFor="let selectableCamera of filteredCameras"
            class="item-card"
            [class.selected]="selectableCamera.selected"
            [class.disabled]="!canSelectMore() && !selectableCamera.selected"
            [class.already-added]="isCameraAlreadyAdded(selectableCamera)"
            (click)="!isCameraAlreadyAdded(selectableCamera) && toggleCamera(selectableCamera)">
            
            <div class="item-checkbox">
              <input 
                type="checkbox" 
                [checked]="selectableCamera.selected"
                [disabled]="(!canSelectMore() && !selectableCamera.selected) || isCameraAlreadyAdded(selectableCamera)"
                (change)="!isCameraAlreadyAdded(selectableCamera) && toggleCamera(selectableCamera)"
                (click)="$event.stopPropagation()">
            </div>
            
            <div class="item-info">
              <div class="item-name">
                <i class="bi bi-camera-video me-2"></i>
                {{ selectableCamera.name }}
              </div>
              <div class="item-meta">
                <span class="me-3" *ngIf="selectableCamera.siteName">
                  <i class="bi bi-building"></i> {{ selectableCamera.siteName }}
                </span>
                <span class="me-3" *ngIf="selectableCamera.siteType">
                  <i class="bi bi-tag"></i> {{ selectableCamera.siteType }}
                </span>
                <span *ngIf="isCameraAlreadyAdded(selectableCamera)" class="badge bg-secondary">
                  Already Added
                </span>
              </div>
              <div class="item-description" *ngIf="selectableCamera.description">
                <small class="text-muted">{{ selectableCamera.description }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onClose()">Cancel</button>
      <button 
        type="button" 
        class="btn btn-primary" 
        [disabled]="selectedCount === 0"
        (click)="onConfirm()">
        <i class="bi bi-plus-lg me-2"></i>
        Add {{ selectedCount }} {{ selectedCount === 1 ? 'Camera' : 'Cameras' }}
      </button>
    </div>
  </div>
</div>
